/**
 * Values that are used for ID attributes in dropdown instances.
 */
export const CONTACT_PAGE_DROPDOWN_SALES_ORG = 'salesOrg';
export const CONTACT_PAGE_DROPDOWN_BUSINESS_UNIT = 'businessUnit';
export const CONTACT_PAGE_DROPDOWN_ROLE = 'role';

/**
 * Text values for business unit keys.
 */
export const CONTACT_PAGE_BUSINESS_UNIT_TEXT_AII = 'Advanced Industrial Intermediates';
export const CONTACT_PAGE_BUSINESS_UNIT_TEXT_FF = 'Flavors & Fragrances';
export const CONTACT_PAGE_BUSINESS_UNIT_TEXT_IPG = 'Inorganic Pigments';
export const CONTACT_PAGE_BUSINESS_UNIT_TEXT_LPT = 'Liquid Purification Technologies';
export const CONTACT_PAGE_BUSINESS_UNIT_TEXT_LAB = 'Lubricant Additives Business';
export const CONTACT_PAGE_BUSINESS_UNIT_TEXT_MPP = 'Material Protection Products';
export const CONTACT_PAGE_BUSINESS_UNIT_TEXT_PLA = 'Polymer Additives';
export const CONTACT_PAGE_BUSINESS_UNIT_TEXT_RCH = 'Rhein Chemie';
export const CONTACT_PAGE_BUSINESS_UNIT_TEXT_SGO = 'Saltigo';
